import React, { useState } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import Reels from '../../pages/home/reels/Reels';

// Placeholder for Chats until we create it
const ChatsPlaceholder = () => (
  <div style={{ padding: '20px', textAlign: 'center' }}>
    <h2>Chats</h2>
    <p>Chat functionality coming soon...</p>
  </div>
);

const TopTabNavigator = () => {
  return (
    <div style={{ height: '100%', width: '100%' }}>
      <Routes>
        <Route path="/" element={<Navigate to="reels" replace />} />
        <Route path="/reels" element={<Reels />} />
        <Route path="/chats" element={<ChatsPlaceholder />} />
      </Routes>
    </div>
  );
};

export default TopTabNavigator;

















